import SectionHeading from '../../components/ui/SectionHeading/SectionHeading.jsx';
import Badge from '../../components/ui/Badge/Badge.jsx';
import DeviceMockup from '../../components/home/DeviceMockup/DeviceMockup.jsx';
import CTASection from '../../components/home/CTASection/CTASection.jsx';
import styles from './Solutions.module.css';

const capabilities = [
  {
    title: 'Interactive previews',
    text: 'Let visitors explore a working interface — real interactions, not a static screenshot — before they sign up.',
    points: ['Browser and phone device frames', 'Hover and scroll-triggered reveals', 'No account required to try it'],
  },
  {
    title: 'A component system that scales',
    text: 'Every button, card, and layout reads from the same design tokens, so new pages stay consistent automatically.',
    points: ['Shared color, type, and spacing tokens', 'CSS Modules per component', 'Easy to extend without duplication'],
  },
  {
    title: 'Content that grows with you',
    text: 'The Insights blog is CMS-powered from day one, so publishing an update doesn\u2019t require a redeploy.',
    points: ['Firestore-backed articles', 'Local fallback content', 'Author, category, and read-time metadata'],
  },
];

const industries = [
  'AI platforms & assistants', 'SaaS startups', 'Mobile app launches', 'Fintech & digital banking',
  'HealthTech & wellness', 'Education & e-learning', 'Productivity tools', 'CRM & business software',
];

export default function Solutions() {
  return (
    <>
      <section className={styles.hero}>
        <div className={`container ${styles.heroGrid}`}>
          <div>
            <Badge tone="secondary">Solutions</Badge>
            <h1 className={styles.title}>Present your product the way it deserves to be seen</h1>
            <p className={styles.lead}>
              Solvora's capabilities are built around one goal: let a visitor understand and trust
              your product before they've committed to trying it.
            </p>
          </div>
          <DeviceMockup />
        </div>
      </section>

      <section className={styles.section}>
        <div className="container">
          {capabilities.map((c, i) => (
            <div key={c.title} className={`${styles.capability} ${i % 2 ? styles.reverse : ''}`}>
              <div className={styles.capabilityText}>
                <span className={styles.capabilityIndex}>{String(i + 1).padStart(2, '0')}</span>
                <h2 className={styles.capabilityTitle}>{c.title}</h2>
                <p className={styles.capabilityDesc}>{c.text}</p>
                <ul className={styles.pointList}>
                  {c.points.map((p) => (
                    <li key={p} className={styles.point}>{p}</li>
                  ))}
                </ul>
              </div>
              <div className={styles.capabilityVisual}>
                <div className={styles.visualPanel}>
                  <div className={styles.visualBar} />
                  <div className={styles.visualRow}>
                    <div className={styles.visualBlock} />
                    <div className={styles.visualBlock} />
                  </div>
                  <div className={styles.visualBlockWide} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.section}>
        <div className="container">
          <SectionHeading eyebrow="Perfect for" title="Built for teams launching something real" align="center" />
          <div className={styles.industryGrid}>
            {industries.map((ind) => (
              <span key={ind} className={styles.industry}>{ind}</span>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
